/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventpublished1Inputs */

const en_eventpublished1 = /** @type {(inputs: Eventpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event published`)
};

const de_eventpublished1 = /** @type {(inputs: Eventpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Event published" |
*
* @param {Eventpublished1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventpublished1 = /** @type {((inputs?: Eventpublished1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventpublished1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventpublished1(inputs)
	return de_eventpublished1(inputs)
});
export { eventpublished1 as "eventPublished" }